import ArticleLoader from "./ArticleLoader";
import ArchiveCard from "../UI/ArchiveCard";
import { setBookmarks } from "../../store/search-actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
const channelIndex = process.env.REACT_APP_PROJECT_INDEX || undefined;

const ArticlesList = ({ articlesList, isLoading, totalPages, error }) => {
  const dispatch = useDispatch();

  const iFrameParentUrl =
    window.location !== window.parent.location
      ? document?.referrer
      : document?.location?.href;
  const isCorrectParent =
    iFrameParentUrl === "https://www.the-syllabus.com/" ||
    iFrameParentUrl === "https://www.the-syllabus.com" ||
    iFrameParentUrl === "http://localhost:3000";
  const showBookmarks =
    isCorrectParent && channelIndex && channelIndex === "syllabus";
  if (showBookmarks) {
    window.addEventListener("message", (event) => {
      if (event.data.id === "bookmarks") {
        const list = event?.data?.list?.length ? event.data.list : [];
        dispatch(setBookmarks([...list]));
      }
      /*  if (event?.data?.type === "bkmrk") {
        
        addBookMarkHandler(event.data.id)
      } */
      /*  console.log(`Received message: ${JSON.stringify(event.data)}`); */
    });
  }
  useEffect(() => {
    if (showBookmarks) {
      window.parent.postMessage({ type: "pageReady" }, "*");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full flex flex-col items-center px-5 lg:px-10">
      {isLoading && <ArticleLoader />}
      {!isLoading && articlesList.length
        ? articlesList.map((a) => <ArchiveCard article={a} key={a.id} />)
        : null}
      {!isLoading && !articlesList.length ? <div>No results</div> : null}
      {error && <h1>ERROR!!</h1>}
    </div>
  );
};

export default ArticlesList;
